// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';

import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import CloneSkuForm from '../components/CloneSkuForm';
import { useTranslation } from 'react-i18next';
import { cloneGameSku } from '../../../api/gameApi';

function Clone({ done, id, gameId, cancel }) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data) => {
    cloneGameSku({ ...data, skuId: id, gameId })
      .then((sku) => {
        toast.success(t('Sku successfully cloned'));
        done(sku.skuId);
      })
      .catch(() => {
        toast.error(t('Failed to clone sku'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Clone sku')}
      cancel={cancel}
      done={done}
      bar={
        <input
          type="submit"
          value={t('Clone')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <CloneSkuForm register={register} errors={errors} control={control} />
    </SlideoutLayout>
  );
}


export default Clone;
